import { SchemaClass } from '@/utils/validator/decorators/decorator.types';

export default function updateSchema(target: typeof SchemaClass, field: keyof (typeof SchemaClass)['schema'], options: unknown): void {
  // eslint-disable-next-line no-param-reassign
  if (!target.schema) target.schema = {};
  const { schema } = target;
  const key = field as keyof typeof schema as string;
  if (schema[key]) schema[key] = [schema[key], options];
  else schema[key] = options;
}
